import { useEffect, useState } from 'react'

/**
 * `value` once it has stopped changing for `delay` ms: what a search box asks the server for, so a
 * word typed is one request rather than one per letter. The address-book combobox and the company
 * selector use it.
 */
export function useDebounced<T>(value: T, delay: number): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])
  return settled
}
